export default __webpack_public_path__ + "static/media/nantesmini.3b9ce2fd.jpg";